import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function AuthDebug() {
  const [isClearing, setIsClearing] = useState(false)
  const [step, setStep] = useState(0)

  const clearAllAuth = async () => {
    setIsClearing(true)
    setStep(1)
    
    try {
      // Step 1: Sign out from Supabase
      setStep(2)
      await supabase.auth.signOut()
      
      // Step 2: Clear all localStorage
      setStep(3)
      localStorage.clear()
      
      // Step 3: Clear sessionStorage
      setStep(4)
      sessionStorage.clear()
      
      // Step 4: Clear specific Supabase keys
      setStep(5)
      const keysToRemove = []
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.includes('supabase')) {
          keysToRemove.push(key)
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key))
      
      setStep(6)
      alert('認証状態をリセットしました。トップページに移動します。')
      
      // Force redirect
      window.location.href = '/'
    } catch (error) {
      console.error('Error clearing auth:', error)
      alert('エラーが発生しましたが、強制的にリダイレクトします。')
      window.location.href = '/'
    }
  }

  const manualSteps = () => {
    return (
      <div className="mt-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <h3 className="font-bold text-yellow-800 mb-2">手動でリセットする方法:</h3>
        <ol className="text-sm text-yellow-700 space-y-1">
          <li>1. ブラウザの開発者ツールを開く (F12)</li>
          <li>2. Application/Storage タブを選択</li>
          <li>3. Local Storage の sales.lunascent.net を全削除</li>
          <li>4. Session Storage も全削除</li>
          <li>5. ページを再読み込み</li>
        </ol>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-lg w-full">
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          認証の問題が発生しています
        </h2>
        
        {step > 0 && (
          <div className="mb-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-blue-700">ステップ {step}: 処理中...</p>
          </div>
        )}
        
        <p className="text-gray-600 mb-6">
          認証状態をリセットして、最初からやり直すことができます。
        </p>
        
        <div className="space-y-4">
          <button
            onClick={clearAllAuth}
            disabled={isClearing}
            className="w-full bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200"
          >
            {isClearing ? '処理中...' : '認証状態をリセット'}
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200"
          >
            強制的にトップページへ
          </button>
          
          <button
            onClick={() => {
              localStorage.clear()
              sessionStorage.clear()
              window.location.reload()
            }}
            className="w-full bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200"
          >
            ブラウザデータをクリア & 再読み込み
          </button>
        </div>
        
        {manualSteps()}
        
        <div className="mt-6 pt-4 border-t border-gray-200">
          <a
            href="/"
            className="text-blue-600 hover:text-blue-800 text-sm underline"
          >
            ← トップページに戻る
          </a>
        </div>
      </div>
    </div>
  )
}